import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import * as storage from '../storage';
import { MatDialog } from '@angular/material/dialog';
import { LoginLoggerService } from '../../services/login-logger.service';

export type SessionState = {
	accessToken: string;
	roles: string;
	familyName: string;
	givenName: string;
	uuid: number;
	timezone: string;
	image: string;
	company: string;
	expiresAt: string;
	complete: boolean;
	id: string;
	mail: null;
	// role: string;
};

export function createInitialSessionState(): SessionState {
	return {
		accessToken: null,
		roles: null,
		familyName: null,
		givenName: null,
		uuid: null,
		timezone: null,
		image: null,
		company: null,
		expiresAt: null,
		complete: null,
		id: null,
		mail: null,
		// role: null,
		...storage.getSession(),
	};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'sessionInfoday' })
export class SessionStore extends Store<SessionState> {
	public dialog: MatDialog;

	constructor(private loginLoggerService: LoginLoggerService) {
		super(createInitialSessionState());
	}

	login(session: any): any {
		// console.log(session);
		const accessToken = session.meta.accessToken;
		const roles = session.data.roles;
		const familyName = session.data.familyName;
		const givenName = session.data.givenName;
		const mail = session.data.email;
		const uuid = session.data.id;
		const timezone = session.data.timezone;
		const image = session.data.image?.url ? session.data.image?.url : '';
		const expiresAt = session.meta.expiresAt;
		const id = session.data.id;

		const company = session.data.company;
		const sapConnectionType = session.data.sapConnectionType;

		let complete = true;
		if (!company || !sapConnectionType) {
			complete = false;
		}

		const creds = {
			accessToken,
			roles,
			familyName,
			givenName,
			uuid,
			id,
			timezone,
			company,
			image,
			expiresAt,
			complete,
			mail,
		};
		this.update(creds);
		storage.saveSession(creds);

		this.loginLoggerService.startLoginLogging(id);
	}

	logout(): any {
		this.loginLoggerService.stopLoginLogging();
		storage.clearSession();
		this.update(createInitialSessionState());
	}
}
